export const QUERY_CART_KEY = "cart";
export const QUERY_PRODUCT_KEY = "product";
export const QUERY_ORDER_KEY = "order";
